const isMobileDevice = () => {
  return /Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
}

export default isMobileDevice
